import { createContext, useContext, useReducer } from 'react';
import type { ReactNode } from 'react';
import { SET_DOC_TYPES } from './actionTypes';
import type { DocTypesState, DocTypesAction, DocumentType } from '@/types';

const DocTypesContext = createContext<DocTypesState>(null);

const DocTypesDispatchContext = createContext<React.Dispatch<DocTypesAction> | null>(null);

const initialState: DocTypesState = null;

interface DocTypesProviderProps {
  children: ReactNode;
}

export function DocTypesProvider({ children }: DocTypesProviderProps) {
  const [doc_types, dispatch] = useReducer(docTypesReducer, initialState);

  return (
    <DocTypesContext.Provider value={doc_types}>
      <DocTypesDispatchContext.Provider value={dispatch}>
        {children}
      </DocTypesDispatchContext.Provider>
    </DocTypesContext.Provider>
  );
}

export function useDocTypes(): DocTypesState {
  return useContext(DocTypesContext);
}

export function useDocTypesDispatch(): React.Dispatch<DocTypesAction> {
  const dispatch = useContext(DocTypesDispatchContext);
  if (!dispatch) {
    throw new Error('useDocTypesDispatch must be used within DocTypesProvider');
  }
  return dispatch;
}

function docTypesReducer(_doc_types: DocTypesState, action: DocTypesAction): DocTypesState {
  switch (action.type) {
    case SET_DOC_TYPES: {
      return [...action.payload].sort((a: DocumentType, b: DocumentType) => {
        if (a.level === b.level) {
          return a.name.localeCompare(b.name);
        } else {
          return a.level - b.level;
        }
      });
    }
    default: {
      throw Error('Unknown action: ' + action);
    }
  }
}
